/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The component that caused over-distribution.
 */
export enum OverdistributionErrorSourceEnum {
    SOURCES = 'SOURCES',
    USES = 'USES',
    OVERRIDES = 'OVERRIDES',
    SECURITIES = 'SECURITIES',
}
